import type { JSX } from 'react';

import { DeleteIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import type { DeleteFacesProps } from '../types';
import { deleteFacesHandler } from './deleteFacesHandler';

function DeleteFacesButton({
  faceIds,
  variant = 'flat',
  'data-testid': dataTestId = 'deleteFacesButton',
  ...props
}: DeleteFacesProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Control.Button
      data-testid={dataTestId}
      icon={<DeleteIcon />}
      kind="negative"
      onClick={deleteFacesHandler(faceIds)}
      variant={variant}
      {...props}
    >
      {props?.children ?? t('monokit:delete faces.buttons.delete')}
    </Control.Button>
  );
}

export { DeleteFacesButton };
